import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { 
    register, kycToken, kycStatus, update, contract, verifyEmailOtp,
    sign, checkEmail, auth, sendEmail, getContract, updatePhone, 
    handleMinikit, getIp, checkPoint, getKioskos, controllerDiscountCode, getDiscountCode, controllerAwards, miniappUser, getMapInfo
} from '../services/users'

// REGISTER A NEW USER
export const registerUser = createAsyncThunk('user/register', async (args, { getState }) => {
    let tempPassword = Math.random().toString(36).substring(2);
    const { user } = getState();
    const response = await register({
        correo: user.email.value,
        password: tempPassword,
        "password-2": tempPassword,
        first_name: "NONE",
        last_name: "NONE",
    });
    return { response: response.data, statusCode: response.status };
});

// REGISTER A NEW USER
export const authUser = createAsyncThunk('user/auth', async (args, { getState }) => {
    const { user } = getState();
    const response = await auth({
        correo: user.email.value,
        password: user.password.value
    });
    return { response: response.data, statusCode: response.status };
});

// UPDATE USER DATA
export const updateUser = createAsyncThunk('user/update', async (args, { getState }) => {
    const { user } = getState();
    const response = await update({ uid: user.id });
    return { response: response.data, statusCode: response.status };
});

// GENERATE CONTRACT
export const generateContract = createAsyncThunk('user/contract', async (args, { getState }) => {
    const { user } = getState();
    const response = await contract({
        email: user.email.value,
        phoneNumber: `+${user.phone.extension} ${user.phone.number}`
    });
    return { response: response.data, statusCode: response.status };
});

// SIGN CONTRACT
export const signContract = createAsyncThunk('user/sign', async (args, { getState }) => {
    const { user } = getState();
    const response = await sign({
        email: user.email.value,
        secret: args.code
    });
    return { response: response.data, statusCode: response.status };
});

// RETRIEVE THE TOKEN FOR SUMSUB VALIDATION
export const getKYCToken = createAsyncThunk('user/kycToken', async (args, { getState }) => {
    const { user } = getState();
    const response = await kycToken({ email: user.email.value });
    return { response: response.data, statusCode: response.status };
});

// RETRIEVE THE USERS KYC STATUS
export const getKYCStatus = createAsyncThunk('user/kyc', async (args, { getState }) => {
    const { user } = getState();
    const response = await kycStatus({ email: user.email.value });
    return { response: response.data, statusCode: response.status };
});

// SEND EMAIL USER
export const sendEmailUser = createAsyncThunk('user/sendEmailUser', async (args, { getState }) => {
    const { user } = getState();
    const response = await sendEmail({ email: user.email.value, type: "miniapp" });
    return { response: response.data, statusCode: response.status };
});

// VERIFY EMAIL USER
export const verifyEmailUser = createAsyncThunk('user/verifyEmailUser', async (args, { getState }) => {
    const { user } = getState();
    const response = await verifyEmailOtp({type: "worldpos", userId: user.id, codeToVerify: args.code });
    return { response: response.data, statusCode: response.status };
});

// MINIAP USER
export const getMiniappUser = createAsyncThunk('user/miniappUser', async (args, { getState }) => {
    const response = await miniappUser({email: args.email });
    return { response: response.data, statusCode: response.status };
});

// CHECK FOR USER EMAIL
export const checkForUser = createAsyncThunk('user/check', async (args, { getState }) => {
    const { user } = getState();
    let emailUser = user.email.value 
    const response = await checkEmail({ email: emailUser});
    return { response: response.data, statusCode: response.status };
});

// GENERATE CONTRACT
export const getOneShotContract = createAsyncThunk('user/getContract', async (args, { getState }) => {
    const { user } = getState();
    const response = await getContract({
        id: user.id,
        client: user.client
    });
    return { response: response.data, statusCode: response.status };
});

// UPDATE USER PHONE NUMBER
export const updateUserPhoneNumber = createAsyncThunk('user/updatePhone', async (args, { getState }) => {
    const { user } = getState();
    const response = await updatePhone({
        id: user.id,
        phoneNumber: `+${user.phone.extension} ${user.phone.number}`
    });
    return { response: response.data, statusCode: response.status };
});

// GET ACTIVATIONS CENTERS
export const getVerifyPoints = createAsyncThunk('user/getVerifyPoints', async (args, { getState }) => {
    // const { user } = getState();
    const response = await checkPoint({});
    let data = response?.data?.Centers?.map((item, index) => ({
        value: (index + 1).toString().padStart(2, "0"),
        label: item
    }));
    return { response: data ? data : {}, statusCode: response.status };
});

// GET KIOSKOS CENTERS
export const getKioskosWLD = createAsyncThunk('user/getKioskosWLD', async (args, { getState }) => {
    // const { user } = getState();
    const response = await getKioskos();
    let data = response?.data?.Centers?.map((item, index) => ({
        value: (index + 1).toString().padStart(2, "0"),
        label: item
    }));
    return { response: data ? data : {}, statusCode: response.status };
});

// GET IP USER
export const getIpCountry = createAsyncThunk('user/getIpCountry', async (args, { getState }) => {
    // const { user } = getState();
    const response = await getIp();
    return { response: response.data, statusCode: response.status };
});

export const handleMinikitUser =  createAsyncThunk('user/handleMinikit', async (args, { getState }) => {
    const { user } = getState();
    let app_id = process.env.REACT_APP_APP_ID;
    args["APP_ID"] = `${app_id}`;
    const response = await handleMinikit({...args, ...{token:user.token}});
    return { response: response.data, statusCode: response.status };
});

export const getDiscountCodeUser =  createAsyncThunk('user/getDiscountCodeUser', async (args, { getState }) => {
    const response = await controllerDiscountCode(args);
    return { response: response.data, statusCode: response.status };
});

export const createDiscountCodeUser =  createAsyncThunk('user/createDiscountCodeUser', async (args, { getState }) => {
    const response = await controllerDiscountCode(args);
    return { response: response.data, statusCode: response.status };
});

export const retrieveMapInfo = createAsyncThunk('user/getMapInfo', async (args, { getState }) => {
    const response = await getMapInfo({...args});
    return { response: response.data, statusCode: response.status };
});

export const infoDiscountCodeUser =  createAsyncThunk('user/infoDiscountCodeUser', async (args, { getState }) => {
    // const { user } = getState();
    const response = await getDiscountCode(args);
    return { response: response.data, statusCode: response.status };
});

export const controllerAwardsFunction =  createAsyncThunk('user/controllerAwardsFunction', async (args, { getState }) => {
    const response = await controllerAwards(args);
    return { response: response.data, statusCode: response.status };
});

// TO VALIDATE ERRORS IN EACH FIELD 
const fieldSetters = {
    email: 'setEmail',
    phone: 'setPhone',
    confirmPhone: 'setConfirmPhone',
    extPhone: 'setPhoneExt',
    dpi: 'setDpi',
    name: 'setUserName',
    last_name: 'setUserLastName',
    country: 'setCountry',
    password: 'setPassword',
    source: 'setUserSource',
    paymentType: 'setUserPaymentType',
    discountCode: 'setUserDiscountCode',
    discountCodePorcent: 'setUserDiscountCodePorcent',
    referalUserDiscountCode: 'setReferalUserDiscountCode'
};

export const userSlice = createSlice({
    name: 'user',
    initialState: {
        idWLD: "",
        token: "",
        sumsubId: "",
        Transactions:[],
        id: "",
        kyc: "none",
        exists: false,
        enableLowExpenses: false,
        oneshot: null,
        client: {},
        ipData: {},
        geoJson: {},
        extPhone: { value: "", error: true },
        phone: { value: "", error: true },
        confirmPhone: { value: "", error: true },
        country: { value: "", error: true },
        email: { value: "", error: true },
        password: { value: "", error: true, checks: {} },
        dpi: { value: "", error: true },
        name: { value: "", error: true },
        last_name: { value: "", error: true },
        source: { value: "", error: true },
        paymentType: { value: "", error: true },
        discountCode: { value: "", error: true },
        discountCodePorcent: { value: 0, error: true },
        referalUserDiscountCode: { value: "", error: true },
    },
    reducers: {
        setEmail: (state, action) => {
            let Value = action.payload.value ?? "";
            state.email.value = Value;
            state.email.error = !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,})+$/.test(Value);
        },
        setIpData: (state, action)=>{
            let Value = action.payload.value ?? "";
            state.ipData = Value;
        },
        setGeoJson: (state, action)=>{
            let Value = action.payload.value ?? "";
            state.geoJson = Value;
        },
        setIdUser: (state, action)=>{
            let Value = action.payload ?? "";
            state.id = Value;
        },
        setKycStatus: (state, action)=>{
            let Value = action.payload ?? {};
            state.kyc = Value;
        },
        setPhone: (state, action) => {
            //---> Para esto deberíamos tener un Endpoint que nos devuelve los datos para validar;
            let LengthsOfPhone = {
                "EC": 9,
                "HN": 8,
                "GT": 8,
                "SV": 8,
                "CR": 8
            };
            let Country = state.country.error ? "GT" : state.country.value?.substr(0, 2);
            let Value = `${action.payload.value ?? ""}`;
            let CountryLength = LengthsOfPhone[Country] ?? 0;
            state.phone.value = Value;
            state.phone.error = new RegExp(`^\\d{${LengthsOfPhone},}$`) && (CountryLength && (`${Value}`.length < CountryLength || `${Value}`.length > CountryLength));
        },
        setConfirmPhone: (state, action) => {
            let Value = `${action.payload.value ?? ""}`;
            state.confirmPhone.value = Value;
            state.confirmPhone.error = Value != state.phone.value && state.confirmPhone.value != state.phone.value;
        },
        setPhoneExt: (state, action) => {
            let Value = `${action.payload.value ?? ""}`;
            state.extPhone.value = Value;
            state.extPhone.error = /^\d{4,}$/.test(Value)
        },
        setDpi: (state, action) => {
            //---> Para esto deberíamos tener un Endpoint que nos devuelve los datos para validar;
            let LengthsOfDPI = {
                "HN": 13,
                "GT": 13,
                "EC": 10,
                "SV": 9,
                "CR": 12
            };
            let Country = state.country.error ? "GT" : state.country.value.substr(0, 2);
            let Value = action.payload.value ?? "";
            let CountryLength = LengthsOfDPI[Country] ?? 0;
            state.dpi.value = Value;
            state.dpi.error = state.country.value == "CR" 
                ? (CountryLength && (`${Value}`.length <= (CountryLength - 4) || `${Value}`.length > (CountryLength))) 
                : (CountryLength && `${Value}`.length != CountryLength);
        },
        setUserName: (state, action) => {
            let Value = action.payload.value ?? "";
            state.name.value = Value;
            state.name.error = Value != "" && !/^[A-Za-záéíóúäëïöüÄËÏÖÜ\s]{3,}$/.test(Value)
        },
        setUserLastName: (state, action) => {
            let Value = action.payload.value ?? "";
            state.last_name.value = Value;
            state.last_name.error = Value != "" && !/^[A-Za-záéíóúäëïöüÄËÏÖÜ\s]{3,}$/.test(Value)
        },
        setCountry: (state, action) => {
            let Value = action.payload.value ?? "";
            state.country.value = Value;
            state.country.error = Value.length < 2;
        },
        setPassword: (state, action) => {
            let Value = action.payload.value ?? "";
            state.password.value = Value;
            state.password.error = Value == "";
        },
        setUserSource: (state, action) => {
            let Value = action.payload.value ?? "";
            state.source.value = Value;
            state.source.error = Value.length < 2;
        },
        setUserPaymentType: (state, action) => {
            let Value = action.payload.value ?? "";
            state.paymentType.value = Value;
            state.paymentType.error = Value=="";
        },
        setUserData: (state, action) => {
            if(action?.payload){
                for(let prop in action.payload){
                    if(state.hasOwnProperty(prop)){
                        const value = action.payload[prop];
                        const setterName = fieldSetters[prop];

                        if (setterName && userSlice.caseReducers[setterName]) {
                            // Reutiliza el reducer existente
                            userSlice.caseReducers[setterName](state, { payload: { value } });
                        } else if (state[prop]?.value !== undefined) {
                            // Para campos simples sin validación personalizada
                            state[prop] = {
                                ...state[prop],
                                value,
                                error: value === "",
                            };
                        } else {
                            state[prop] = value;
                        }
                    };
                };
                if(action.payload.nullifier_hash){ state.idWLD = action.payload.nullifier_hash; }
                if(action.payload.token){ state.token = action.payload.token; }
            };
        },
        setUserDiscountCode: (state, action) => {
            let Value = action.payload.value ?? "";
            state.discountCode.value = Value;
            state.discountCode.error = Value != "" && !/^[A-Z]{3}[0-9]{3}$/.test(Value)
        },
        setUserDiscountCodePorcent: (state, action) => {
            let Value = action.payload.value ?? 0;
            state.discountCodePorcent.value = Value;
            state.discountCodePorcent.error = Value==0;
        },
        setReferalUserDiscountCode: (state, action) => {
            let Value = action.payload.value ?? "";
            state.referalUserDiscountCode.value = Value;
            state.referalUserDiscountCode.error = Value=="";
        },
    },
    extraReducers: builder => {
        builder
            // registerUser REDUCER
            .addCase(registerUser.fulfilled, (state, { payload }) => {
                const { response } = payload;
                if (response.ok && !response.user.error) { state.id = response.user.user.uid; }
            })
            .addCase(registerUser.rejected, (state, action) => { state.id = null; })
            // registerUser REDUCER
            .addCase(authUser.fulfilled, (state, { payload }) => {
                const { response } = payload;
                if (!response.error) {
                    state.id = response.uid;
                    state.kyc = response.kyc;
                    state.oneshot = response.oneshot;
                    [state.phone.extension, state.phone.number] = response.phone.split(" ");
                    state.client = response.client;
                }
            })
            .addCase(authUser.rejected, (state, action) => { state.id = null; })
            // checkForUser REDUCER
            .addCase(checkForUser.fulfilled, (state, { payload }) => {
                const { response } = payload;
                if (response.statusCode === 200) state.exists = true;
                else state.exists = false;
            })
            .addCase(checkForUser.rejected, (state) => { state.exists = false; })
    }
})

// Action creators are generated for each case reducer function
export const { setEmail, setPassword, setPhone, setCountry, setDpi, setUserName, setUserLastName, setUserSource, setUserPaymentType, 
    setPhoneExt, setConfirmPhone, setUserData, setUserDiscountCode, setUserDiscountCodePorcent, setReferalUserDiscountCode, 
    setKycStatus, setIdUser, setIpData, setGeoJson } = userSlice.actions
export default userSlice.reducer